import React, {useState, useEffect} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Modal, Button, Form, Popup, Icon} from 'semantic-ui-react';
import {
  dateFormatPicker,
  yearFormatPicker,
  yearFormat,
  reverseShortDate,
} from '../../../../common/constants/datesFormat';

const vehicle = {
  'chassis': '',
  'dealerId': '',
  'motorNumber': '',
  'model': '',
  'description': '',
  'modelYear': '',
  'salesDate': '',
};

const ModalComfirm = ({chassis, dealerId, addWarrantyChassis}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [newVehicle, setNewVehicle] = useState({...vehicle, 'dealerId': dealerId, 'chassis': chassis});
  const [invalidForm, setInvalidForm] = useState(true);

  useEffect(() => {
    if (!Object.keys(newVehicle).some((key) => !newVehicle[key])) {
      setInvalidForm(false);
    } else {
      setInvalidForm(true);
    }
  }, [newVehicle]);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleSaveVehicle = () => {
    const data = {
      ...newVehicle,
      'modelYear': Number(moment(newVehicle.modelYear).format(yearFormat)),
      'salesDate': moment(newVehicle.salesDate).format(reverseShortDate),
    };
    addWarrantyChassis(chassis, data);
    handleCloseModal();
  };

  const handleChange = (e, {name, value}) => {
    setNewVehicle({...newVehicle, [name]: value});
  };

  const handleChangeDate = (field, date) => {
    setNewVehicle({...newVehicle, [field]: date});
  };

  return (
    <Modal
      className="new-vehicle-modal"
      open={isOpen}
      trigger={
        <Popup
          inverted
          position="top center"
          content="Agregar vehículo"
          trigger={<Icon name="add" color="red" onClick={handleOpenModal} />}
        />
      }
    >
      <Modal.Header>Ingreso vehículo</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Group widths="equal">
            <Form.Input
              fluid
              label="Chasis"
              placeholder="Chasis"
              name="chassis"
              required
              readOnly
              value={newVehicle.chassis}
            ></Form.Input>
            <Form.Input
              fluid
              label="Motor"
              placeholder="Motor"
              name="motorNumber"
              required
              value={newVehicle.motorNumber}
              onChange={handleChange}
            ></Form.Input>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              fluid
              label="Modelo"
              placeholder="Modelo"
              name="model"
              required
              value={newVehicle.model}
              onChange={handleChange}
            ></Form.Input>
            <Form.Input
              fluid
              label="Descripción"
              placeholder="Descripción"
              name="description"
              required
              value={newVehicle.description}
              onChange={handleChange}
            ></Form.Input>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input fluid label="Año de fabricación" required>
              <DatePicker
                placeholderText="Año de fabricación"
                className="tcc-datepicker"
                showYearPicker
                selected={
                  newVehicle.modelYear ?
                    moment(newVehicle.modelYear).toDate() :
                    null
                }
                dateFormat={yearFormatPicker}
                onChange={(value) => handleChangeDate('modelYear', value)}
                locale="es"
                required
              />
            </Form.Input>
            <Form.Input fluid required label="Fecha de venta">
              <DatePicker
                placeholderText="Fecha de venta"
                className="tcc-datepicker"
                showYearDropdown
                selected={
                  newVehicle.salesDate ?
                    moment(newVehicle.salesDate).toDate() :
                    null
                }
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChangeDate('salesDate', value)}
                locale="es"
                required
              />
            </Form.Input>
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCloseModal}>Cerrar</Button>
        <Button disabled={invalidForm} onClick={handleSaveVehicle} color="green">
          Guardar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalComfirm;
